/**
 * Basic metadata of the file
 */

export function isFileType(type) {
  return type === 'file' || type === 'directory';
}
export function isDirectory(file) {
  return file.type === 'directory';
}

/**
 * A file including it's contents
 */

/**
 * FileStorage abstraction. Has methods for managing files, and for retrieving a table to browse files.
 */
//# sourceMappingURL=FileStorage.js.map